import React from 'react'

interface ITimeAndDateInfo {
  label: string;
  value: string | number | React.ReactNode | undefined;
  className: string;
  isBold?: boolean;
  subText?: string;
  wrapperClassName?: string;
  valueClassName?: string;
}
export default function TimeAndDateInfo({ wrapperClassName, className, label, value, isBold, subText, valueClassName }: ITimeAndDateInfo) {
  return (
    <div className={wrapperClassName}>
      <div style={{ margin: 0 }}>
        <p className={className}>{label}</p>
        {subText && <p>{subText}</p>}
      </div>
      {value && <p style={isBold ? { fontWeight: "bolder" } : undefined}>{value}</p>}
    </div>
  )
}
